'use strict';

export default class IconController {

  /*@ngInject*/
  constructor($http, $state, $stateParams, toaster) {
    this.$http = $http;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.toaster = toaster;
  }

  $onInit() {
    this.getApp();
    this.getBetaGroups();
  }

  getApp() {
    this.$http.get('/api/apps/' + this.$stateParams.id).then(response => {
      this.app = response.data;
    });
  }

  checkStr(str) {
    if (str) {
      str = str.trim();
    }
    return str;
  }

  checkArr(arr) {
    let res = false;
    arr.forEach(item => {
      if (item.trim().length > 0) {
        res = true;
      }
    });
    return res;
  }

  checkData() {
    if (this.checkStr(this.app.packageName) && this.checkStr(this.app.type) 
    && this.checkStr(this.app.channel) && this.app.versionCode && this.checkStr(this.app.platform) 
    && this.checkArr(this.app.changeLogs.zh_CN)) {
      return true;
    }

    this.toaster.pop({
      type: 'error',
      title: '请填写必填项',
      timeout: 3 * 1000
    });
    return false;
  }

  update() {
    this.app.type = this.app.type.toLowerCase();
    this.app.channel = this.app.channel.toLowerCase();
    this.app.platform = this.app.platform.toLowerCase();
    this.app.deviceMAC = this.app.deviceMAC.map(mac => {
      return mac.toLowerCase();
    });
    if (!this.checkData()) {
      return;
    }
    this.$http.put(`api/apps/${this.app._id}`, this.app).then(response => {
      this.$state.go('apps');
    });
  }

  getBetaGroups() {
    this.$http.get('/api/betaGroups').then(res => {
      this.betaGroups = res.data;
    });
  }

  toggleSelection(id) {
    let idx = this.app.betaGroups.indexOf(id);

    if (idx > -1) {
      this.app.betaGroups.splice(idx, 1);
    } else {
      this.app.betaGroups.push(id);
    }
  }

}



// WEBPACK FOOTER //
// ./client/app/apps/edit/edit.controller.js